import ResponsiveTable from "./ResponsiveRequestTable"

// El viejo TableComponent ahora usa ResponsiveTable internamente
// Mantiene compatibilidad hacia atrás
const TableComponent = (props) => <ResponsiveTable {...props} />

export default TableComponent
